import styled from 'styled-components';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { LAYOUT_VARS } from './CustomFormsWorkflow.meta';

export const ScrollableWrapper = styled.div(({ theme }) => ({
  minWidth: LAYOUT_VARS.minPageWidth,
  background: theme.background.replace(/;/g, ''),
  paddingTop: theme.space['48'],
}));

interface ContentProps {
  stepListHeight: number;
}

export const Content = styled(Box)<ContentProps>(({ stepListHeight }) => ({
  height: `calc(100% - ${stepListHeight + LAYOUT_VARS.gridGap}px)`,
}));

interface CollectionProps {
  isCompleted: boolean;
}

export const Collection = styled(Box)<CollectionProps>(({ theme, isCompleted }) => ({
  padding: '12px 16px',
  borderRadius: theme.radii.medium,
  border: `1px solid ${theme.colors.neutral[300]}`,
  backgroundColor: theme.colors.bg,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: theme.space['16'],
  minHeight: 66,
  position: 'relative',
  transition: `background ${theme.transitions.normal}`,

  '&:not([aria-disabled=true]):hover': {
    backgroundColor: theme.colors.neutral[100],
  },

  '&[aria-current=true]': {
    backgroundColor: isCompleted ? theme.colors.success[50] : theme.colors.primary[50],
    borderColor: isCompleted ? theme.colors.success[500] : theme.colors.primary[500],

    '&:not([aria-disabled=true]):hover': {
      backgroundColor: theme.colors.success[50],
    },

    '&::before': {
      content: "''",
      position: 'absolute',
      height: 40,
      width: 4,
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      borderRadius: '0px 2px 2px 0px',
      background: isCompleted ? theme.colors.success[500] : theme.colors.primary[500],
    },
  },

  '&[aria-disabled=true]': {
    cursor: 'unset',
  },
}));

interface MainProps {
  headerHeight: number;
}

export const Main = styled(Box).attrs({ as: 'main' })<MainProps>(({ headerHeight }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: `calc(100vh - ${244 + headerHeight}px)`,
}));
